import './InputOptions.svelte.css';
/* src/components/searchControl/InputOptions.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	set_data,
	set_store_value,
	space,
	text
} from "../../../_snowpack/pkg/svelte/internal.js";

import { onMount } from '../../../_snowpack/pkg/svelte.js';
import { inputValues } from '../../stores/storeInputOptions.js';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[8] = list[i];
	return child_ctx;
}

// (59:2) {#each options as option}
function create_each_block(ctx) {
	let option;
	let t0_value = /*option*/ ctx[8].label + "";
	let t0;
	let t1;
	let option_value_value;
	let option_selected_value;

	return {
		c() {
			option = element("option");
			t0 = text(t0_value);
			t1 = space();
			option.__value = option_value_value = /*option*/ ctx[8].value;
			option.value = option.__value;
			option.selected = option_selected_value = /*option*/ ctx[8].selected;
			attr(option, "class", "svelte-awrc8v");
		},
		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t0);
			append(option, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*options*/ 1 && t0_value !== (t0_value = /*option*/ ctx[8].label + "")) set_data(t0, t0_value);

			if (dirty & /*options*/ 1 && option_value_value !== (option_value_value = /*option*/ ctx[8].value)) {
				option.__value = option_value_value;
				option.value = option.__value;
			}

			if (dirty & /*options*/ 1 && option_selected_value !== (option_selected_value = /*option*/ ctx[8].selected)) {
				option.selected = option_selected_value;
			}
		},
		d(detaching) {
			if (detaching) detach(option);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let label;
	let t0;
	let t1;
	let select;
	let mounted;
	let dispose;
	let each_value = /*options*/ ctx[0];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			div = element("div");
			label = element("label");
			t0 = text(/*titleLabel*/ ctx[3]);
			t1 = space();
			select = element("select");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(label, "for", /*itemId*/ ctx[1]);
			attr(select, "id", /*itemId*/ ctx[1]);
			attr(select, "name", /*itemName*/ ctx[2]);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, label);
			append(label, t0);
			append(div, t1);
			append(div, select);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(select, null);
			}

			if (!mounted) {
				dispose = listen(select, "blur", /*changeOption*/ ctx[4]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*titleLabel*/ 8) set_data(t0, /*titleLabel*/ ctx[3]);

			if (dirty & /*itemId*/ 2) {
				attr(label, "for", /*itemId*/ ctx[1]);
			}

			if (dirty & /*options*/ 1) {
				each_value = /*options*/ ctx[0];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(select, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*itemId*/ 2) {
				attr(select, "id", /*itemId*/ ctx[1]);
			}

			if (dirty & /*itemName*/ 4) {
				attr(select, "name", /*itemName*/ ctx[2]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			destroy_each(each_blocks, detaching);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $inputValues;
	component_subscribe($$self, inputValues, $$value => $$invalidate(5, $inputValues = $$value));
	let { id: itemId } = $$props;
	let { name: itemName } = $$props;
	let { label: titleLabel } = $$props;
	let { options } = $$props;

	onMount(async () => {
		await initOptions();
	});

	/**
 * inputイベントを受け取って、itemIdのinputValuesストアを更新する
 */
	function sendOptions(e) {
		set_store_value(inputValues, $inputValues[itemId] = e.target.value, $inputValues);
	}

	/**
 * inputが変更されたときのハンドラ
 * @param  {[type]} e [description]
 * @return void
 */
	async function changeOption(e) {
		await sendOptions(e);
	}

	/**
 * inputValuesストア内にitemIdが存在すれば、optionsのselectedを変更する
 *
 * @return void
 */
	function initOptions() {
		if ($inputValues[itemId]) {
			if (!options.find(({ value }) => value === $inputValues[itemId])) {
				set_store_value(inputValues, $inputValues[itemId] = 'none', $inputValues);
			}

			Object.keys(options).forEach(k => {
				if (options[k].value === $inputValues[itemId]) {
					$$invalidate(0, options[k].selected = true, options);
				} else {
					$$invalidate(0, options[k].selected = false, options);
				}
			});
		}
	}

	$$self.$$set = $$props => {
		if ('id' in $$props) $$invalidate(1, itemId = $$props.id);
		if ('name' in $$props) $$invalidate(2, itemName = $$props.name);
		if ('label' in $$props) $$invalidate(3, titleLabel = $$props.label);
		if ('options' in $$props) $$invalidate(0, options = $$props.options);
	};

	return [options, itemId, itemName, titleLabel, changeOption];
}

class InputOptions extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { id: 1, name: 2, label: 3, options: 0 });
	}
}

export default InputOptions;